import React, { useCallback, useEffect, useMemo } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { Box } from '@material-ui/core'
import Tabs from '../../../molecules/Tabs'
import VaultTagsAdmin from './VaultTagsAdmin'
import VaultDocumentAdmin from './VaultDocumentAdmin'
import VaultMigrationAdmin from './VaultMigrationAdmin'

const VALID_TABS = ['documents', 'tags', 'migration']

const VaultAdmin = () => {
  const history = useHistory()
  const location = useLocation()

  const selectedTab = useMemo(() => {
    const pathAfterVault = location.pathname.replace('/admin/vault', '').replace(/^\//, '')
    const tabKey = pathAfterVault.split('/')[0]
    return VALID_TABS.includes(tabKey) ? tabKey : null
  }, [location.pathname])

  useEffect(() => {
    if (!selectedTab) {
      history.replace('/admin/vault/documents')
    }
  }, [selectedTab, history])

  const tabOptions = [
    { label: 'Manage Documents', value: 'documents' },
    { label: 'Manage Tags', value: 'tags' },
    { label: 'Document Migration', value: 'migration' }
  ]

  const handleSelectValue = useCallback((value) => {
    if (selectedTab === value) return
    history.push(`/admin/vault/${value}`)
  }, [selectedTab, history])

  return (
    <Box px={2}>
      <Tabs.Wrapper noMargin>
        <Tabs
          value={selectedTab || 'documents'}
          indicatorColor='primary'
          textColor='primary'
          onChange={(_, tabValue) => {
            handleSelectValue(tabValue)
          }}
        >
          {tabOptions.map((o) => {
            return (
              <Tabs.Tab
                key={o.value}
                value={o.value}
                label={o.label}
                disabled={o.disabled}
              />
            )
          })}
        </Tabs>
      </Tabs.Wrapper>
      {selectedTab === 'documents' && (
        <VaultDocumentAdmin />
      )}
      {selectedTab === 'tags' && (
        <VaultTagsAdmin />
      )}
      {selectedTab === 'migration' && (
        <VaultMigrationAdmin />
      )}
    </Box>
  )
}

export default VaultAdmin
